module.exports = __webpack_public_path__ + "img/sozialschnellgut_8_a.147d6173.jpg";